import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const KmCheckService = {
    apply: async (payload) => axios.post(API_URL + "/km_check/apply", payload).then(({ data }) => data).catch((err) => { throw err }),
};

export default KmCheckService;